"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolbarGridDecorators = void 0;
const react_1 = __importDefault(require("react"));
const Toolbar_1 = require("@veeam/components/lib/Toolbar");
require("@veeam/components/lib/Toolbar/types");
const simple = ({ groups, view } = {}) => (toolbarItems, payload) => react_1.default.createElement(Toolbar_1.Toolbar, { items: toolbarItems, payload: payload, groups: groups, view: view });
exports.toolbarGridDecorators = {
    simple,
};
//# sourceMappingURL=toolbarGridDecorators.js.map